import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function EditUser() {
  const { token } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    email: '',
    role: 'Employee',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch user by ID on mount
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForm({
          name: res.data.name,
          email: res.data.email,
          role: res.data.role,
        });
        setLoading(false);
      } catch (err) {
        setError('Failed to load user');
        setLoading(false);
      }
    };
    fetchUser();
  }, [id, token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}/api/users/${id}`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/users');
    } catch (err) {
      setError('Update failed');
    }
  };

  if (loading) return <p>Loading user...</p>;

  return (
    <div className="container mt-4">
      <h2>Edit User</h2>
      {error && <p className="text-danger">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name:</label>
          <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Email:</label>
          <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>Role:</label>
          <select className="form-select" name="role" value={form.role} onChange={handleChange}>
            <option value="Employee">Employee</option>
            <option value="IT">IT</option>
            <option value="Executive">Executive</option>
          </select>
        </div>
        <button type="submit" className="btn btn-success">Update</button>
      </form>
      <Link to="/users" className="btn btn-sm btn-outline-secondary me-2 mt-3">Back</Link>
    </div>
  );
}